import React, { FC } from 'react'
import Container from 'components/container'
import { Section, Heading, Table, Th } from './styled'
import TableCell from './TableCell'
import zip from 'lodash/zip'

type Props = {
  heading: string
  headingIsHtml?: boolean
  tableContent: any
}

const Comparison: FC<Props> = ({ heading, headingIsHtml, tableContent }) => {
  const { checks, crosses } = tableContent
  if (!Array.isArray(checks) || !Array.isArray(crosses) || checks.length !== crosses.length) {
    throw new Error('Checks and Crosses must be arrays of equal length.')
  }

  const displayArray = zip(checks, crosses)

  return (
    <Section>
      <Container>
        {headingIsHtml ? (
          <Heading dangerouslySetInnerHTML={{ __html: heading }} />
        ) : (
          <Heading>{heading}</Heading>
        )}
        <Table>
          <thead>
            <tr>
              <Th>Traditional Lab</Th>
              <Th><span translate="no">Fellow</span></Th>
            </tr>
          </thead>
          <tbody>
            {displayArray.map(([check, cross]) => (
              <tr key={`${check['headline']}${cross['headline']}`}>
                <TableCell
                  headline={cross['headline']}
                  text={cross['text']}
                  check={false}
                />
                <TableCell
                  headline={check['headline']}
                  text={check['text']}
                />
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </Section>
  )
}

export default Comparison
